<template>
  <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Módulo de reporte de ventas
      </h2>
    <MainReportSales />
  </div>
</template>

<script>
import MainReportSales from "@/components/Reports/Sales/General/MainReportSales.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "SalesReport",
  components: {
    MainReportSales,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
